import { useEffect, useRef, useState } from "react";

export interface ElementSize {
	width: number;
	height: number;
}

export const useElementSize = <T extends HTMLElement = HTMLDivElement>(): [React.RefObject<T | null>, ElementSize] => {
	const ref = useRef<T>(null);
	const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 });

	useEffect(() => {
		const element = ref.current;
		if (!element) {
			return;
		}

		const observer = new ResizeObserver(entries => {
			const entry = entries[0];
			if (!entry) {
				return;
			}

			setSize({ width: entry.contentRect.width, height: entry.contentRect.height });
		});

		observer.observe(element);
		return () => observer.disconnect();
	}, []);

	return [ref, size];
};
